import { ReactNode } from 'react';

import {
  Modal as ChakraModal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  ModalProps as ChakraModalProps
} from '@chakra-ui/react';

interface ModalProps extends ChakraModalProps {
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
}

const Modal = ({ children, isOpen, onClose, ...stylesProps }: ModalProps) => (
  <ChakraModal
    isCentered
    size='xl'
    isOpen={isOpen}
    onClose={onClose}
    {...stylesProps}
  >
    <ModalOverlay />
    <ModalContent maxWidth='unset' margin='11px'>
      <ModalCloseButton />
      <ModalBody padding={0}>{children}</ModalBody>
    </ModalContent>
  </ChakraModal>
);

export default Modal;
